import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const DoorLiteLites = ({ value, onChange, numberOfLites, label = 'Lites' }) => {
    const [selectedDoorLiteLites, setSelectedDoorLiteLites] = useState(value || '');
    const [liteOptions, setLiteOptions] = useState([]);

    const handleDoorLiteLitesChange = (e) => {
        const newValue = e.target.value;
        setSelectedDoorLiteLites(newValue);
        onChange(newValue); // Pass the selected value to the parent
    };

    // Update options based on the number of lites
    useEffect(() => {
        if (!numberOfLites || isNaN(numberOfLites) || numberOfLites <= 0) {
            setLiteOptions([]);
            return;
        }

        if (numberOfLites === 1) {
            setLiteOptions([{ value: '1', label: '1 Lite' }]);
        } else {
            const options = Array.from({ length: numberOfLites }, (_, index) => ({
                value: String(index + 1),
                label: `${index + 1} Lite${index + 1 > 1 ? 's' : ''}`,
            }));
            setLiteOptions(options);
        }
    }, [numberOfLites]);

    // Automatically set selected value to "1" when options change
    useEffect(() => {
        if (liteOptions.length > 0) {
            setSelectedDoorLiteLites(liteOptions[0].value);
            onChange(liteOptions[0].value); // Ensure parent is updated
        }
    }, [liteOptions]);

    return (
        <div className="a-container">
            {numberOfLites > 0 && liteOptions.length > 1 && (
                <>
                    <label htmlFor="DoorLiteLites">{label}</label>
                    <select
                        id="DoorLiteLites"
                        value={selectedDoorLiteLites}
                        onChange={handleDoorLiteLitesChange}
                    >
                        {liteOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {selectedDoorLiteLites === option.value
                                    ? `${option.label} ✔`
                                    : option.label}
                            </option>
                        ))}
                    </select>
                </>
            )}
        </div>
    );
};

export default DoorLiteLites;
